const CHECKOUT = {
  order_or_request: 'Order or Request',
  details: 'Details',
  summary: 'Summary',
  order: 'Order',
  request: 'Request',
  continue_as: 'Continue with {label}',
  lkw_ramp: 'LKW with hydraulic ramp',
  delivery_date: 'Desired delivery date',
  buy_order: 'Place order (payment required)',
  place_request: 'Send request',
  contact_at_location: 'Person at the Construction',
  project: 'Project',
  binding_order: 'Please choose:',
  next_to_checkout: 'Go To Checkout',
  type: 'Type',
  adjoining_area: 'Adjoining Area',
  reference_id: 'Reference - / Order number',
};

export default CHECKOUT;
